/* eslint-disable class-methods-use-this */
import { cloneDeep } from 'lodash';
import CollectionApi from 'client/api/v2/CollectionApi';

/** gRPC gateway requires filter and search params in specific format:
 *  ?filter[0]=active:eq:1&filter[1]=name:search:ab
 */
class PasswordManagerCollectionApi extends CollectionApi {
  /** overrides parent method */
  setFilterTerm(params, filters = [], searchTerm) {
    let apiFilters = [];

    if (filters) {
      apiFilters = filters.map(({ name, operator, value }) => `${name}:${operator}:${value}`);
    }

    const searchFields = params?.search?.fields;

    let searchFilters = [];

    if (searchFields && searchTerm) {
      searchFilters = searchFields.map(searchFied => `${searchFied}:search:${searchTerm}`);
    }

    return apiFilters.concat(searchFilters);
  }

  /** overrides parent method */
  setSearchTerm(params) {
    if (params) {
    // eslint-disable-next-line no-param-reassign
      delete params.search;
    }
  }

  fetchTotalCount(filters = [], searchTerm) {
    const params = { ...cloneDeep(this.defaultParams) };
    delete params.skip;
    delete params.limit;
    delete params.sort;

    params.filter = this.setFilterTerm(params, filters, searchTerm);
    this.setSearchTerm(params, searchTerm);

    const url = `${this.baseUrl}?${this.param(params)}`;
    return this.getAllItemsCount(url);
  }
}

export default PasswordManagerCollectionApi;
